import LoadingSpinner from './LoadingSpinner';

/**
 * Student ID filter — visible label, partial match text input, optional datalist suggestions.
 * Supports comma-separated IDs (e.g. VE2026-00001, VE2026-00002).
 */
const StudentIdFilterField = ({ field, value, onChange, onFocus, loading, isLoading }) => {
  const { name, label } = field;
  const options = field.options || [];

  return (
    <div className="relative">
      <label
        htmlFor={`filter-${name}`}
        className="block text-sm font-medium mb-1 truncate"
        style={{ color: 'var(--color-text)' }}
        title={label}
      >
        {label}
      </label>
      <input
        id={`filter-${name}`}
        type="text"
        name={name}
        placeholder="e.g. VE2026-00001"
        value={value ?? ''}
        onChange={onChange}
        onFocus={onFocus}
        disabled={loading || isLoading}
        autoComplete="off"
        className="w-full px-3 py-2 border rounded disabled:opacity-50 disabled:cursor-not-allowed text-sm"
        list={`${name}-options`}
      />
      <datalist id={`${name}-options`}>
        {options.map((option, index) => (
          <option key={index} value={option.value} label={option.label} />
        ))}
      </datalist>
      {isLoading && <LoadingSpinner />}
    </div>
  );
};

export default StudentIdFilterField;
